import { CommonModule, DecimalPipe } from "@angular/common";
import { Component, OnDestroy, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { DecimalConfigService } from 'app/services/decimal-config.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import {
  MatPaginatorIntl,
} from "@angular/material/paginator";
import {
  MatSidenavContainer,
  MatSidenavModule,
} from "@angular/material/sidenav";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { SmartGridComponent, ColDef, GridConfig, PageChangedEvent, SortChangedEvent } from 'app/shared/components/smart-grid';
import { OrderPaymentAService } from "./order-payment.service";
import { PaymentImagesCellRendererComponent } from './cell-renderers/payment-images-cell-renderer.component';
import { RouteUserCellRendererComponent } from './cell-renderers/route-user-cell-renderer.component';
import { BusinessPartnerCellRendererComponent } from './cell-renderers/business-partner-cell-renderer.component';
import { PaymentTypeCellRendererComponent } from './cell-renderers/payment-type-cell-renderer.component';
import { BankOperationCellRendererComponent } from './cell-renderers/bank-operation-cell-renderer.component';
import { BankCellRendererComponent } from './cell-renderers/bank-cell-renderer.component';
import { SubRouteService } from "app/modules/components/routing/sub-routes/sub-route.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import OrderPaymentAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/process/order-payment/order-payment.entity";
import { BankAttributes, PaymentMethodsAttributes, PaymentTypeAttributes, SubRouteAttributes } from "@albatrosdeveloper/ave-models-package";
import { getCode } from "app/utils/method";
import { Subscription } from "rxjs";
import { FormatOtherDateHourPipe } from "app/pipes/other-date.pipe";
import { ImageCarouselComponent } from "../../visits/visit-report/modal-image/modal-image.component";
import { MatDialog } from "@angular/material/dialog";
import { NgSelectComponent } from "@ng-select/ng-select";
import { MonedaPipe } from "app/pipes/moneda.pipe";
import { MatSelectModule } from "@angular/material/select";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatBadgeModule } from "@angular/material/badge";
import { ExportService } from "app/layout/export-overlay/export-overlay.service";
import { ExportDialogComponent } from 'app/layout/export-overlay/dialog/export-dialog.component';
import { ExportOptions } from "app/layout/export-overlay/tasks/core/export-task.interfaces";
import { OrderPaymentExport } from "./exports/order-payment.export";
import { ORDER_PAYMENT_TITLE } from "./exports/order-payment.constants";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { FilterSectionComponent } from "app/common/components/filter-section/filter-section.component";
import { BusinessPartnersFiltersComponent } from "app/modules/components/filters/business-partners-filters/business-partners-filters.component";
import { ConfigurationFiltersComponent } from "app/modules/components/filters/configuration-filters/configuration-filters.component";
import { DatesFiltersComponent } from "app/modules/components/filters/dates-filters/dates-filters.component";
import { FinanceFiltersComponent } from "app/modules/components/filters/finance-filters/finance-filters.component";
import { RoutesFiltersComponent } from "app/modules/components/filters/routes-filters/routes-filters.component";
import { StatusFiltersComponent } from "app/modules/components/filters/status-filters/status-filters.component";
import { PaymentTypeService } from "app/modules/components/payment-master/payment-type/payment-type.service";
import { BankService } from "app/modules/components/payment-master/bank/bank.service";
import { PaymentMethodService } from "app/modules/components/payment-master/payment-method/payment-method.service";
import { OrderPaymentAttributesExt } from "app/modules/components/collections/dto/payment-management.interface";
import { UserRouteDisplayComponent } from "app/shared/components/user-route-display/user-route-display.component";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { MatMenuModule, MatMenuTrigger } from "@angular/material/menu";
import { DateHelper } from "app/utils/date.helper";
import { CompanyCurrencyPipe } from "app/pipes/currency.pipe";


@Component({
  selector: "app-order-payment",
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatButtonModule,
    MatIconModule,
    SmartGridComponent,
    MatSidenavModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    FormatOtherDateHourPipe,
    MonedaPipe,
    NgSelectComponent,
    MatTooltipModule,
    MatBadgeModule,
    FilterComponent,
    FilterSectionComponent,
    DatesFiltersComponent,
    ConfigurationFiltersComponent,
    RoutesFiltersComponent,
    BusinessPartnersFiltersComponent,
    FinanceFiltersComponent,
    StatusFiltersComponent,
    UserRouteDisplayComponent,
    HoverMenuDirective,
    MatMenuModule,
    CompanyCurrencyPipe,
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    OrderPaymentExport,
    MonedaPipe,
    FormatOtherDateHourPipe,
  ],
  templateUrl: "./order-payment.component.html",
  styleUrl: "./order-payment.component.scss",
})
export class OrderPaymentComponent implements OnInit, OnDestroy {
  getCode = getCode;
  private decimalPipe = new DecimalPipe("en-US");

  data: OrderPaymentAttributes[] = [];
  columnDefs: ColDef<OrderPaymentAttributes>[] = [];
  gridConfig: GridConfig<any> = {
    rowIdField: "_id" as any,
    emptyState: {
      message: "No encontramos tus resultados!",
      showIcon: true,
    },
    pagination: {
      enabled: true,
      mode: "api",
      pageSize: 50,
      pageSizeOptions: [50, 100, 150, 200],
      showPaginator: true,
    },
    sorting: {
      enabled: true,
      mode: "api",
      multiColumn: false,
      defaultSort: [{ field: "total" as any, direction: "desc" }],
    },
    search: {
      enabled: false,
    },
    columnFilters: {
      enabled: true,
      mode: "local",
    },
    columnVisibility: {
      enabled: false, // Disabled - now in settings panel
    },
    selection: {
      enabled: false,
    },
    autoSizing: {
      enabled: true,
      includeHeaders: true,
      skipHidden: true,
      padding: 40, // Increased for more spacing
    },
    styling: {
      maxHeight: "85vh",
      minHeight: "80vh",
      density: "comfortable",
      fontSize: "12px",
      cellPaddingX: "3px",
      cellPaddingY: "3px",
    },
    settingsPanel: {
      enabled: true,
      position: "right",
      enableColumnVisibility: true,
      defaultDensity: "compact",
    },
  };

  totalItems: number = 0;
  searchControl = new FormControl("");
  search: string = "";
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof OrderPaymentAttributes = "amount";
  sortDirection: "ASC" | "DESC" = "DESC";
  selectedRouteIds: string[] = [];

  filter = {
    dateini: new Date(),
    dateend: new Date(),
  };

  range = new FormGroup({
    start: new FormControl<Date | null>(new Date()),
    end: new FormControl<Date | null>(new Date()),
  });

  paymentStatus: { id: number; name: string }[] = [
    { id: 7, name: "Aceptado" },
    { id: 8, name: "Rechazado" },
  ];

  selectedPayment: number = null;

  subRouteList: SubRouteAttributes[] = [];
  listFilterSubRouteList: SubRouteAttributes[] = [];
  searchSubRoute = "";

  //BUSCADOR
  searchSubscription: Subscription;
  isLoading: boolean = false;

  form: FormGroup;

  selectedStatuses: number[] = [];

  selectedERPStatuses: number[] = [];

  bankList: BankAttributes[] = [];

  paymentMethodFilterList: PaymentMethodsAttributes[] = [];

  paymentTypeList: PaymentTypeAttributes[] = [];

  loadConfigData = false;
  loadRoutesData = false;
  loadBusinessPartnersData = false;
  loadFinanceData = false;

  constructor(
    private orderpaymentService: OrderPaymentAService,
    private readonly subRouteService: SubRouteService,
    private readonly searchService: SearchService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    public exportService: ExportService,
    private orderPaymentExport: OrderPaymentExport,
    private fb: FormBuilder,
    private readonly paymentTypeService: PaymentTypeService,
    private readonly bankService: BankService,
    private readonly paymentMethodService: PaymentMethodService,
    private monedaPipe: MonedaPipe,
    private formatOtherDateHourPipe: FormatOtherDateHourPipe,
    private companyCurrencyPipe: CompanyCurrencyPipe,
    private decimalConfigService: DecimalConfigService
  ) {
    const today = new Date();

    this.form = this.fb.group({
      start: [today],
      end: [today],
      companyId: [],
      subRouteId: [],
      customerId: [[]],
      paymentTypeId: [[]],
      paymentMethodId: [[]],
      bankId: [[]],
    });

    // Inicializar columnDefs en el constructor para evitar ExpressionChangedAfterItHasBeenCheckedError
    this.initializeColumnDefs();
  }

  onConfigExpanded(): void {
    this.loadConfigData = true;
  }

  onRoutesExpanded(): void {
    this.loadRoutesData = true;
  }

  onBusinessPartnersExpanded(): void {
    this.loadBusinessPartnersData = true;
  }

  onFinanceExpanded(): void {
    if (!this.loadFinanceData) {
      this.fetchAllPaymentMethod();
      this.fetchAllPaymentType();
      this.fetchAllBank();
    }

    this.loadFinanceData = true;
  }

  private fetchAllPaymentMethod(): void {
    this.paymentMethodService.findToComboBox().subscribe({
      next: (res) => {
        this.paymentMethodFilterList = res.data;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener metodos de pago.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  private fetchAllPaymentType(): void {
    this.paymentTypeService.findToComboBox().subscribe({
      next: (res) => {
        this.paymentTypeList = res.data;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener tipo de pago.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  private fetchAllBank(): void {
    this.bankService.findToComboBox().subscribe({
      next: (res) => {
        this.bankList = res.data;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener bancos.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  ngOnInit(): void {
    this.onHandleSearch();
  }

  ngAfterViewInit(): void {
    // Llamar findAllWithCount en el próximo ciclo para evitar ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.findAllWithCount();
    }, 0);
    // this.fetchAllRoutes();
  }

  private fetchAllRoutes(): void {
    this.subRouteService.findToComboBox().subscribe({
      next: (res) => {
        this.subRouteList = res.data;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener rutas.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  private initializeColumnDefs(): void {
    this.columnDefs = [
      {
        headerName: "",
        minWidth: 80,
        sortable: false,
        cellRenderer: PaymentImagesCellRendererComponent,
        cellRendererParams: {
          onImageClick: (data: any) => {
            if (data?.paymentImages && data.paymentImages.length > 0) {
              this.openImageCarousel(data.paymentImages);
            }
          },
        },
      },
      {
        field: "subRoute" as any,
        headerName: "Ruta - Usuario",
        minWidth: 300,
        sortable: true,
        cellRenderer: RouteUserCellRendererComponent,
        filterOptions: {
          valueExtractor: (item: any) => item.subRoute?.name,
          customFilterFn(rowData, filterValue) {
            const subRouteName = rowData.subRoute?.name;
            if (!subRouteName) return !filterValue;
            return subRouteName === filterValue;
          },
        },
      },
      {
        field: "shipTo" as any,
        headerName: "Socio de Negocio",
        minWidth: 200,
        sortable: true,
        cellRenderer: BusinessPartnerCellRendererComponent,
        filterOptions: {
          valueExtractor: (item: any) => item.shipTo?.name,
          customFilterFn(rowData, filterValue) {
            const businessPartnerName = rowData.shipTo?.name;
            if (!businessPartnerName) return !filterValue;
            return businessPartnerName === filterValue;
          },
        },
      },
      {
        field: "serials",
        headerName: "Documento",
        minWidth: 150,
        sortable: true,
        valueFormatter: (value, data) => {
          return String(value || "-");
        },
      },
      {
        field: "paymentMethod" as any,
        headerName: "Tipo/Método Pago",
        minWidth: 180,
        sortable: true,
        cellRenderer: PaymentTypeCellRendererComponent,
        filterOptions: {
          valueExtractor: (item: any) => item.paymentMethod?.name,
          customFilterFn(rowData, filterValue) {
            const paymentMethodName = rowData.paymentMethod?.name;
            if (!paymentMethodName) return !filterValue;
            return paymentMethodName === filterValue;
          },
        },
      },
      {
        field: "dateHour",
        headerName: "Fecha",
        minWidth: 150,
        sortable: true,
        valueFormatter: (value, data) => {
          if (!value) return "-";
          return this.formatOtherDateHourPipe.transform(value, true);
        },
        filterOptions: {
          valueExtractor(item) {
            if (!item.dateHour) return "";
            const date = new Date(item.dateHour);
            return date.toLocaleDateString("es-ES", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            });
          },
          customFilterFn(rowData, filterValue) {
            const rowDate = rowData.dateHour;
            if (!rowDate) return !filterValue;
            const rowDateObj = new Date(rowDate);
            const rowDateStr = rowDateObj.toLocaleDateString("es-ES", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            });
            return rowDateStr === filterValue;
          },
        },
      },
      {
        field: "bankOperation",
        headerName: "Nro. Letra",
        minWidth: 150,
        sortable: true,
        cellRenderer: BankOperationCellRendererComponent,
      },
      {
        field: "bank" as any,
        headerName: "Banco",
        minWidth: 150,
        sortable: true,
        cellRenderer: BankCellRendererComponent,
        filterOptions: {
          valueExtractor: (item: any) => item.bank?.name,
          customFilterFn(rowData, filterValue) {
            const bankName = rowData.bank?.name;
            if (!bankName) return !filterValue;
            return bankName === filterValue;
          },
        },
      },
      {
        field: "operationNumber",
        headerName: "Operación",
        minWidth: 120,
        sortable: true,
        valueFormatter: (value, data) => {
          return String(value || "-");
        },
        cellClass: "text-right font-semibold pr-20",
      },
      {
        field: "paying",
        headerName: "Abono",
        minWidth: 150,
        sortable: true,
        valueFormatter: (value, data) => {
          if (value == null) return "-";
          return this.monedaPipe.transform(value);
        },
        cellClass: "text-right font-semibold pr-20",
        filterOptions: this.createCurrencyFilterOptions("paying"),
      },
      {
        field: "amount",
        headerName: "Pago Total",
        minWidth: 150,
        sortable: true,
        valueFormatter: (value, data) => {
          if (value == null) return "-";
          return this.monedaPipe.transform(value);
        },
        cellClass: "text-right font-semibold pr-20",
        filterOptions: this.createCurrencyFilterOptions("amount"),
      },
    ];
  }

  onClearFilter() {
    this.filter = {
      dateini: new Date(),
      dateend: new Date(),
    };
    this.selectedRouteIds = [];
    this.search = "";
    this.findAllWithCount();
  }

  onPageChange(event: PageChangedEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.findAllWithCount();
  }

  onSortChange(event: SortChangedEvent<OrderPaymentAttributes>): void {
    if (event.sortStates.length > 0) {
      const sortState = event.sortStates[0];
      this.sortActive = sortState.field as keyof OrderPaymentAttributes;
      this.sortDirection = sortState.direction === "asc" ? "ASC" : "DESC";
    } else {
      this.sortActive = "amount";
      this.sortDirection = "DESC";
    }
    this.findAllWithCount();
  }

  private getSortField(): keyof OrderPaymentAttributes {
    const sortFieldMapping: Record<string, keyof OrderPaymentAttributes> = {
      subRoute: <any>"subRoute.name",
      user: <any>"user.user_login.username",
      serials: <any>"serials",
      date: <any>"dateHour",
      shipToExternalKeyCode: <any>"shipToExternalKeyCode",
    };
    return sortFieldMapping[this.sortActive] || "amount";
  }

  public totoUTCISODate(date: Date, isStartOfDay: boolean): string {
    const localDate = new Date(date);

    if (isStartOfDay) {
      localDate.setHours(0, 0, 0, 0);
    } else {
      localDate.setHours(23, 59, 59, 999);
    }

    return localDate.toISOString();
  }

  private getSortFieldByTrip(): keyof OrderPaymentAttributesExt {
    const sortFieldMapping: Record<string, keyof OrderPaymentAttributesExt> = {
      shipTo: <any>"shipTo.name",
      user: <any>"user.user_login.username",
      trip: <any>"trip.id",
      balance: <any>"balance",
      amount: <any>"amount",
      date: "dateHour",
    };
    return sortFieldMapping[this.sortActive] || "dateHour";
  }

  findAllWithCount(): void {
    const sortField = this.getSortFieldByTrip() as keyof OrderPaymentAttributes;
    const routeIds = this.form.get("subRouteId")?.value;

    let date = {
      start: DateHelper.getStartOfDay(this.form.get("start")?.value),
      end:
        DateHelper.getEndOfDay(this.form.get("end")?.value) ??
        DateHelper.getEndOfDay(this.form.get("start")?.value) ??
        null,
    };

    let dataFilter = {
      paymentTypeIds: this.form.get("paymentTypeId")?.value,
      paymentMethodIds: this.form.get("paymentMethodId")?.value,
      bankIds: this.form.get("bankId")?.value,
      businessIds: this.form.get("customerId")?.value,
    };

    this.isLoading = true;
    this.orderpaymentService
      .findAllWithCount(
        {
          currentPage: this.pageIndex,
          limitPerPage: this.pageSize,
          search: this.search,
          sort: sortField,
          sortDirection: this.sortDirection,
        },
        date,
        routeIds,
        this.selectedStatuses,
        this.selectedERPStatuses,
        dataFilter
      )
      .subscribe((data) => {
        this.data = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.isLoading = false;
      });
  }

  getSelectedRouteCodes(selectedRouteIds: string[]): number[] {
    return selectedRouteIds.map(
      (id) => this.subRouteList.find((group) => group._id.toString() === id)?.id
    );
  }

  getSelectedPayment(selectedPayment: number): number | undefined {
    return this.paymentStatus.find((group) => group.id === selectedPayment)?.id;
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.search = input.value.trim();
    if (this.search.length >= 2 || this.search.length === 0) {
      // this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$.subscribe(
      (term) => {
        this.search = term;
        if (this.search.length >= 2 || this.search.length === 0) {
          this.findAllWithCount();
        }
      }
    );
  }

  openImageCarousel(images: any[]) {
    const imageLinks = images.map((image) => image.image.link);
    const dialogRef = this.dialog.open(ImageCarouselComponent, {
      panelClass: "form-modal",
      disableClose: true,
      data: { images: imageLinks },
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  onExportButtonPressed() {
    if (!this.orderPaymentExport.canStartTask()) return;
    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: ORDER_PAYMENT_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.orderPaymentExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex
        );
      }
    });
  }

  /**
   * Format a number as currency with symbol and thousands separators
   * Example: 1250.5 -> "L 1,250.50"
   */
  private formatCurrency(value: number): string {
    if (value == null) return "-";

    const decimals = this.decimalConfigService.getDecimals();
    const formattedNum =
      this.decimalPipe.transform(value, `1.${decimals}-${decimals}`) ?? "-";

    if (formattedNum === "-") return "-";

    const symbol = this.companyCurrencyPipe.transform("symbol");
    return `${symbol} ${formattedNum}`;
  }

  /**
   * Create filterOptions for monetary columns
   * Reusable for paying, amount
   */
  private createCurrencyFilterOptions(fieldPath: string) {
    return {
      valueExtractor: (item: any) => {
        const value = item[fieldPath];
        return this.formatCurrency(value);
      },
      customFilterFn: (rowData: any, filterValue: string) => {
        const value = rowData[fieldPath];
        const formattedValue = this.formatCurrency(value);
        if (!formattedValue || formattedValue === "-") return !filterValue;
        return formattedValue === filterValue;
      },
    };
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
